import { makeAutoObservable } from "mobx"

class GlobalAppState {
  kill = null;
  ticket = null;
  ticketDisplay = null;
  burnTicket = null;
  maxOdds = null;
  oracleAppId = null;
  freeDrawNft = null;
  maxRandomnessRange = null;
  rewardsPoolAmount = null;
  pausingAt = null;
  pausingSoon = null;
  isPaused = null;
  royaltyAmount = 0;

  constructor(newObj) {
    makeAutoObservable(this);
  }

  get ticketDisplayAlgo() {
    return this.ticketDisplay / 1_000_000;
  }

  get ticketAlgo() {
    return this.ticket ? this.ticket / 1_000_000 : 0;
  }

  get burnTicketAlgo() {
    return this.burnTicket ? this.burnTicket / 1_000_000 : 0;
  }

  get rewardsPoolAmountAlgo() {
    return ((this.rewardsPoolAmount  + this.royaltyAmount)/ 1_000_000).toLocaleString(undefined, { maximumFractionDigits: 2 });
  }

  setState(newState) {
    for(const key of Object.keys(newState)) {
      if (!this.hasOwnProperty(key)) {
        console.warn('GlobalAppState replaceState tried to set unknown key '+key);
        continue;
      }
      this[key] = newState[key];
    }
  }

  replaceState(newState) {
    this.resetState();
    this.setState(newState);
  }

  resetState() {
    for(const key of Object.keys(this)) {
      this[key] = null;
    }
  }
}

export default GlobalAppState;
